<template>
  <v-layout v-resize="onResize" column style="padding-top: 56px">
    <v-data-table
      flat
      :headers="headers"
      :items="deposits"
      :loading="loadingData"
      click:row
      :rows-per-page-items="limitOptions"
      class="elevation-2"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
      :pagination.sync="pagination"
      :total-items="totalResources"
    >
      <template slot="items" slot-scope="props">
        <tr v-if="!isMobile">
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            {{ props.item.id }}
          </td>
          <td v-else class="text-xs-left">
            {{ props.item.id }}
          </td>
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            {{ getTipoDisplay(props.item.tipo) }}
          </td>
          <td v-else class="text-xs-left">
            {{ getTipoDisplay(props.item.tipo) }}
          </td>

          <td v-if="props.item.is_fee" class="is-fee">
            {{ dueDate(props.item.due_on) }}
          </td>
          <td v-else>{{ dueDate(props.item.due_on) }}</td>
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            {{ diffDate(new Date(props.item.due_on)) }}
          </td>
          <td v-else class="text-xs-left">
            {{ diffDate(new Date(props.item.due_on)) }}
          </td>

          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            <span v-if="props.item.tipo === 'withdraw'">
              Saque #{{ props.item.installment_number }}
            </span>
            <router-link
              v-else-if="props.item.payment_uuid"
              :to="{ name: 'payment', params: { id: props.item.payment_id } }"
            >
              {{ props.item.payment_uuid }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td v-else class="text-xs-left">
            <span v-if="props.item.tipo === 'withdraw'">
              Saque #{{ props.item.installment_number }}
            </span>
            <router-link
              v-else-if="props.item.payment_uuid"
              :to="{ name: 'payment', params: { id: props.item.payment_id } }"
            >
              {{ props.item.payment_uuid }}
            </router-link>
            <span v-else>-</span>
          </td>
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            {{ $n("-" + props.item.amount, "currency") }}
          </td>
          <td v-else class="text-xs-left">
            {{ $n(props.item.amount, "currency") }}
          </td>
          <td class="text-xs-left">
            <span v-if="props.item.tipo === 'withdraw'">
              {{ $n(props.item.amount, "currency") }}
            </span>
            <span v-else>
              {{ $n(props.item.payment_amount, "currency") }}
            </span>
          </td>
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            <v-chip
              :class="setClass(props.item.status)"
              small
              text-color="white"
            >
              {{ $t(`status.${props.item.status}`) }}
            </v-chip>
          </td>
          <td v-else class="text-xs-left">
            <v-chip
              :class="setClass(props.item.status)"
              small
              text-color="white"
            >
              {{ $t(`status.${props.item.status}`) }}
            </v-chip>
          </td>
          <td v-if="props.item.is_fee" class="text-xs-left is-fee">
            <span v-if="props.item.tipo === 'withdraw'">-</span>
            <span v-else>
              {{
                props.item.installment_number +
                "/" +
                props.item.payment_installments
              }}
            </span>
          </td>
          <td v-else class="text-xs-left">
            <span v-if="props.item.tipo === 'withdraw'">-</span>
            <span v-else>
              {{
                props.item.installment_number +
                "/" +
                props.item.payment_installments
              }}
            </span>
          </td>
          <td class="text-xs-left">
            <payment-brand v-if="props.item.tipo !== 'withdraw'" :brand="props.item.payment_credit_card_brand" :size="32" />
            <span v-else>-</span>
          </td>
          <td class="text-xs-left">
            <span v-if="props.item.tipo === 'withdraw'">-</span>
            <span v-else>{{ props.item.payment_authorization_code || '-' }}</span>
          </td>
          <td class="text-xs-left">
            <span v-if="props.item.tipo === 'withdraw'">-</span>
            <span v-else-if="props.item.payment_nsu === null">-</span>
            <span v-else>{{ props.item.payment_nsu }}</span>
          </td>
        </tr>
        <tr v-else>
          <td>
            <ul class="flex-content">
              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="ID Depósito"
              >
                {{ props.item.id }}
              </li>
              <li v-else class="flex-item" data-label="ID Depósito">
                {{ props.item.id }}
              </li>
              
              <li
                v-if="props.item.is_fee"
                class="is-fee flex-item"
                data-label="Tipo"
              >
                {{ getTipoDisplay(props.item.tipo) }}
              </li>
              <li v-else class="flex-item" data-label="Tipo">
                {{ getTipoDisplay(props.item.tipo) }}
              </li>

              <li
                v-if="props.item.is_fee"
                class="is-fee flex-item"
                data-label="Data para depósito"
              >
                {{ dueDate(props.item.due_on) }}
              </li>
              <li v-else class="flex-item" data-label="Data para depósito">
                {{ dueDate(props.item.due_on) }}
              </li>

              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="Dias para depósito"
              >
                {{ diffDate(new Date(props.item.due_on)) }}
              </li>
              <li v-else class="flex-item" data-label="Dias para depósito">
                {{ diffDate(new Date(props.item.due_on)) }}
              </li>

              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="Referente ao pagamento"
              >
                <span v-if="props.item.tipo === 'withdraw'">
                  Saque #{{ props.item.installment_number }}
                </span>
                <router-link
                  v-else-if="props.item.payment_uuid"
                  :to="{
                    name: 'payment',
                    params: { id: props.item.payment_id },
                  }"
                >
                  {{ props.item.payment_uuid }}
                </router-link>
                <span v-else>-</span>
              </li>
              <li
                v-else
                class="flex-item"
                style="margin-top: 25px"
                data-label="Referente ao pagamento"
              >
                <span v-if="props.item.tipo === 'withdraw'">
                  Saque #{{ props.item.installment_number }}
                </span>
                <router-link
                  v-else-if="props.item.payment_uuid"
                  :to="{
                    name: 'payment',
                    params: { id: props.item.payment_id },
                  }"
                >
                  {{ props.item.payment_uuid }}
                </router-link>
                <span v-else>-</span>
              </li>

              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="Valor da parcela"
              >
                {{ $n("-" + props.item.amount, "currency") }}
              </li>
              <li v-else class="flex-item" data-label="Valor da parcela">
                {{ $n(props.item.amount, "currency") }}
              </li>
              <li class="flex-item" data-label="Valor do pagamento">
                <span v-if="props.item.tipo === 'withdraw'">
                  {{ $n(props.item.amount, "currency") }}
                </span>
                <span v-else>
                  {{ $n(props.item.payment_amount, "currency") }}
                </span>
              </li>

              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="Status"
              >
                <v-chip
                  :class="setClass(props.item.status)"
                  small
                  text-color="white"
                >
                  {{ $t(`status.${props.item.status}`) }}
                </v-chip>
              </li>
              <li v-else class="flex-item" data-label="Status">
                <v-chip
                  :class="setClass(props.item.status)"
                  small
                  text-color="white"
                >
                  {{ $t(`status.${props.item.status}`) }}
                </v-chip>
              </li>

              <li
                v-if="props.item.is_fee"
                class="is_fee flex-item"
                data-label="Parcela"
              >
                <span v-if="props.item.tipo === 'withdraw'">-</span>
                <span v-else>
                  {{
                    props.item.installment_number +
                    "/" +
                    props.item.payment_installments
                  }}
                </span>
              </li>
              <li v-else class="flex-item" data-label="Parcela">
                <span v-if="props.item.tipo === 'withdraw'">-</span>
                <span v-else>
                  {{
                    props.item.installment_number +
                    "/" +
                    props.item.payment_installments
                  }}
                </span>
              </li>
              <li class="flex-item" data-label="Bandeira">
                <payment-brand v-if="props.item.tipo !== 'withdraw'" :brand="props.item.payment_credit_card_brand" :size="32" />
                <span v-else>-</span>
              </li>
              <li class="flex-item" data-label="Autorização">
                <span v-if="props.item.tipo === 'withdraw'">-</span>
                <span v-else>{{ props.item.payment_authorization_code || '-' }}</span>
              </li>
              <li class="flex-item" data-label="NSU">
                <span v-if="props.item.tipo === 'withdraw'">-</span>
                <span v-else>{{ props.item.payment_nsu || '-' }}</span>
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { changed } from "@/helpers/layout";
import moment from "moment";

export default {
  created() {
    this.$store.dispatch("deposits/load");
  },
  components: {
    PaymentBrand: () => import("@/components/desktop/brand/PaymentBrand.vue"),
  },
  computed: {
    ...mapGetters({
      deposits: "deposits/resources",
      limit: "deposits/limit",
      page: "deposits/page",
      totalResources: "deposits/totalResources",
      limitOptions: "deposits/limitOptions",
      filters: "deposits/filter",
      loadingData: "deposits/loadingData",
      showFilters: "deposits/showFilters",
    }),
  },
  methods: {
    ...mapActions({
      updateLimit: "deposits/updateLimit",
      updateCurrentPage: "deposits/updateCurrentPage",
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `deposit ${status}`;
    },
    dueDate(dueOn) {
      return moment(dueOn).format("DD/MM/YYYY");
    },
    diffDate(depositDate) {
      const now = Date.now();
      const remainingDays = parseInt(
        (depositDate - now) / (1000 * 60 * 60 * 24),
        10
      );
      if (remainingDays > 0) {
        return remainingDays;
      }
      return 0;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    replaceDot(value) {
      return value.replace(".", ",");
    },
    getTipoDisplay(tipo) {
      const tipoMap = {
        'payment': 'Pagamento',
        'withdraw': 'Saque',
        'fee': 'Tarifa'
      };
      return tipoMap[tipo] || tipo;
    },
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      isMobile: false,
      headers: [
        { text: "ID Depósito", value: "id" },
        { text: "Tipo", value: "tipo" },
        { text: this.$t("phrases.depositDate"), value: "depositDate" },
        { text: this.$t("phrases.daysForDeposit"), value: "daysForDeposit" },
        { text: this.$t("phrases.forThePayment"), value: "forThePayment" },
        { text: this.$t("words.value"), value: "value" },
        { text: this.$t("words.valueToReceive"), value: "valueToReceive" },
        { text: this.$t("status.status"), value: "status" },
        { text: this.$t("words.installment"), value: "installment" },
        { text: this.$t("words.cardBrand"), value: "cardBrand" },
        {
          text: this.$t("words.authorization"),
          value: "payment_authorization_code",
        },
        { text: "nsu", value: "payment_nsu" },
      ],
    };
  },
  watch: {
    loadingData(newValue) {
      // console.log("Is loadingData, new Value: " + newValue)
    },
    pagination: function pagination(newPagination, oldPagination) {
      if (changed(newPagination.rowsPerPage, oldPagination.rowsPerPage)) {
        this.updateLimit(newPagination.rowsPerPage);
        this.$store.dispatch("deposits/load");
      }
      if (changed(newPagination.page, oldPagination.page)) {
        this.updateCurrentPage(newPagination.page);
        this.$store.dispatch("deposits/load");
      }
    }
  }
};
</script>
<style>
.mobile {
  color: #333;
}
@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }
  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid #b2b2b8;
  }
  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #636366;
  }
  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }
  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
  margin-top: 25px;
}
.v-chip.deposit.all {
  background-color: #757575 !important;
}
.v-chip.deposit.scheduled {
  background-color: #1565c0 !important;
}
.v-chip.deposit.processing {
  background-color: #546e7a !important;
}
.v-chip.deposit.cancelled {
  background-color: #b71c1c !important;
}
.v-chip.deposit.completed {
  background-color: #1b5e20 !important;
}
.v-chip.deposit.failed {
  background-color: #e53935 !important;
}
.v-chip.deposit.downed {
  background-color: #ef6c00 !important;
}
.v-chip.deposit.anticipated {
  background-color: #006064 !important;
}
.is-fee {
  color: rgb(255, 0, 0);
  font-weight: bold !important;
}
</style>
